import config from "@utils/config";

/**
 * Host every share link points at.
 *
 * `open.lissen.com` is an app-associated domain: an installed app opens the
 * link natively without ever touching HTTP, crawlers get per-content Open
 * Graph tags from the open-link worker, and everyone else is 302'd to the web
 * app. Dev has no open host, so it shares the web app directly.
 */
const SHARE_LINK_BASE_URL =
  config.PROJECT_ID === "lissendev"
    ? "https://app.lissendev.lissen.com"
    : "https://open.lissen.com";

/**
 * Drop expo-router group segments (`/(app)`, `/(tabs)`) from a route.
 *
 * Groups organise layouts; they never appear in a web URL and mean nothing to
 * whoever receives the link, so shared URLs use the clean form:
 * `/(app)/(tabs)/explore/artist/1` → `/explore/artist/1`.
 */
export const stripRouteGroups = (path: string): string => {
  const queryStart = path.search(/[?#]/);
  const pathname = queryStart === -1 ? path : path.slice(0, queryStart);
  const suffix = queryStart === -1 ? "" : path.slice(queryStart);
  const cleanedPathname = pathname.replace(/\/\([^/]*\)/g, "");

  return `${cleanedPathname || "/"}${suffix}`;
};

/** Public, shareable URL for an in-app route. */
export const buildShareUrl = (path: string): string =>
  `${SHARE_LINK_BASE_URL}${stripRouteGroups(path)}`;
